export const enquiryTypes = [
  {
    iso: "dontKnow",
    name:
      "Product information requested (technical/price/availability) & I DO NOT know the part number",
  },
  {
    iso: "know",
    name:
      "Product information requested (technical/price/availability) & I DO know the part number",
  },
  {
    iso: "sponsor",
    name: "Sponsorship enquiry",
  },
  {
    iso: "other",
    name: "Other questions or comments",
  },
];

export const driveStyles = [
  {
    iso: "daily",
    name: "Daily street driver",
  },
  {
    iso: "commercial",
    name: "Commercial vehicle",
  },
  {
    iso: "towing",
    name: "4WD / Towing",
  },
  {
    iso: "armoured",
    name: "Armoured vehicle",
  },
  {
    iso: "motorsport",
    name: "Motorsport",
  },
];
